import { render, staticRenderFns } from "./Ciclo_evaluaciones_agregar.vue?vue&type=template&id=118f5f33&scoped=true"
import script from "./Ciclo_evaluaciones_agregar.vue?vue&type=script&lang=js"
export * from "./Ciclo_evaluaciones_agregar.vue?vue&type=script&lang=js"
import style0 from "./Ciclo_evaluaciones_agregar.vue?vue&type=style&index=0&id=118f5f33&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118f5f33",
  null
  
)

export default component.exports